export enum SegmentedsAggregations {
    HourOfDay = 'HourOfDay',
    Date = 'Date',
    Week= 'Week',
    Month = 'Month',
    Quarter = 'Quarter'
}
